import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ForAllService } from "../for-all.service";
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { MatSnackBar } from "@angular/material/snack-bar";
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { PreguntasService } from "app/main/pagina/productos/certificar/tipo_2/preguntas/preguntas.service";
import { lang_cerv3 } from 'app/idiomas/i18n/cerV3/cerv3.lang';
import { ModalComponent } from "app/main/pagina/productos/certificar/tipo_2/preguntas/reactivos-v3/preguntas/modal/modal.component";
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'traducciones',
  templateUrl: './traducciones.component.html',
  styleUrls: ['./traducciones.component.scss']
})
export class TraduccionesComponent implements OnInit {


  // @Input() actualizaTraducciones: Observable<any>;
  @Input() idiomasGuardados: Observable<any>;
  comunicacionPaso: any;
  @Input() statusPaso: Observable<any>;
  idiomaNative: string;
  idiomasAdicionales: any[] = [];
  comunicacionSecciones: any;
  @Input() seccionesGuardadas: Observable<any>;
  comunicacionStatusCompletado: any;
  comunicacionIdiomas: any;

  @Output() actualizaCuestionario: EventEmitter<any> = new EventEmitter();
  @Output() traduccionesCompletas: EventEmitter<any> = new EventEmitter();

  cargando = true;
  guardando: boolean;
  pasoCompleto: boolean;

  practicas: any;
  idiomas: any;
  traducciones: any;
  traduccionesOriginal: any;
  jsonCuestionario: any;
  tipoSeccion: any;
  seccionesDemo: any[] = [];
  catalogoRespForall: any;
  configTemplate: any;

  constructor(
    private forallService: ForAllService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private translateSrv: TranslateService,
    private preguntasService: PreguntasService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    public sanitizer: DomSanitizer,
    private dialog: MatDialog,
  ) {
    lang_cerv3.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
  });
}

  ngOnInit() {
    this.comunicacionIdiomas = this.idiomasGuardados.subscribe( (datos:any) => {
      console.log("estos son los datos¨¨",datos);

      if(datos != null){
        console.log("se envio datos desde componente base: ",datos);
        this.idiomas = datos;
        let indiceIdiomaNativo = this.idiomas.findIndex(item => item.tipoIdioma == "1");
        this.idiomaNative = this.idiomas[indiceIdiomaNativo].nombreIdioma;
        this.idiomas.forEach(idioma => {
          if(idioma.tipoIdioma == '0'){
            this.idiomasAdicionales.push(idioma);
          }
        });
        this.cargando = false;
      }
    });

    this.comunicacionSecciones = this.seccionesGuardadas.subscribe( (datos:any) => {
      console.log("comunicacionSecciones desde componente base: ",datos);
      if(datos != null){
        this.jsonCuestionario = datos.jsonCuestionario;
        this.tipoSeccion = datos.tipoSeccion;
        this.catalogoRespForall = datos.catalogoRespForall;
        this.configTemplate = datos.configTemplate;
        this.setSeccionesDemo(datos.tipoSeccion);
      }
    });

    this.comunicacionStatusCompletado = this.statusPaso.subscribe( (datos:any) => {
      console.log("entro lo del paso completo");
      if(datos != null){
        this.pasoCompleto = datos;
      }
    });
  }

  setSeccionesDemo(tipoSeccion: number){
    this.seccionesDemo = [];
    this.jsonCuestionario.sections.forEach((seccion:any) => {
      if(seccion.typeSection == tipoSeccion){
        seccion.pendientesMC = false;
        //revisa el nombre de la seccion si no tiene traduccion
        if(tipoSeccion == 6){
          seccion.pendientesForAll = false;
        }
        //revisa las preguntas que aun no tienen traduccion
        seccion.questions.forEach(pregunta => {
          pregunta.questionLanguage.forEach(traduccion => {
            if(traduccion.question == "" || traduccion.practice4all == "" || traduccion.description4all == ""){
              traduccion.pendiente = true;
            }
            else traduccion.pendiente = false;
          });
        });
        this.seccionesDemo.push(seccion);
      }
      this.traduccionesOriginal = JSON.parse(JSON.stringify(this.seccionesDemo));
      this.revisaTraduccionesCompletas();
    });
    console.log("seccionesDemoTranslate:",this.seccionesDemo);
  }

  revisaTraduccionesCompletas(){
    let traduccionesOK = true;
    let BreakException = {};
    try {
      this.seccionesDemo.forEach(seccion => {
        this.idiomasAdicionales.forEach(langAdicional => {
          //revisa las preguntas que aun no tienen traduccion
          let BrkExc2 = {};
          let tradRespOk = true;
          try {
            seccion.questions.forEach((pregunta,i) => {
              let BrkInt1 = {};
              let tradPregOk = true;
              try {
                pregunta.questionLanguage.forEach(traduccion => {
                  if(traduccion.lang == langAdicional.nombreIdioma){
                    if(traduccion.question == "" || traduccion.practice4all == ""){
                      tradPregOk = false;
                      throw BrkInt1;
                    }
                    if(i % 2 == 0){
                      if(traduccion.description4all == ""){
                        tradPregOk = false;
                        throw BrkInt1;
                      }
                    }
                  }
                });
              } catch (e) {
                if (e !== BrkInt1) throw e;
              };
              if(!tradPregOk){
                tradRespOk = false;
                throw BrkExc2;
              }
            });
          } catch (e) {
            if (e !== BrkExc2) throw e;
          };
          if(!tradRespOk){
            traduccionesOK = false;
            throw BreakException;
          }
        });
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    console.log("traduccionesCompletas:",traduccionesOK);
    this.traduccionesCompletas.emit(traduccionesOK);
  }

  guardaTraduccionForall(event:any, datosTraduccion:any, indiceSeccion:number, indicePregunta:number, indiceIdioma:number, tipoTexto:number, accion:number){
    console.log("preguntaMod:",indicePregunta);

    if(event.target.value.length >= 1){
      let textoOriginal: any;
      switch (tipoTexto) {
        case 1: //practica
          textoOriginal = this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].practice4all;
        break;
        case 2: //descripcion
          textoOriginal = this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].description4all;
        break;
      }
      if(textoOriginal != event.target.value)
      {
        // this.guardando = true;
        $(document).ready(function(){ $(':focus').blur(); });
        this.modalGuardado(accion);
        console.log("datosTraduccion:",datosTraduccion);
        if(datosTraduccion.pendiente){
          datosTraduccion.pendiente = false;
        }
        //actualiza la pregunta a los dos statements
        // let datosStt1 = this.seccionesDemo[indiceSeccion].questions[indicePregunta - 1].questionLanguage[indiceIdioma];
        // let indiceIdiomaStt1 = this.catalogoRespForall[0].questionLanguage.findIndex(item => item.lang == datosStt1.lang);
        // let indiceIdiomaStt2 = this.catalogoRespForall[1].questionLanguage.findIndex(item => item.lang == datosTraduccion.lang);
        let datosStt2 = this.seccionesDemo[indiceSeccion].questions[indicePregunta + 1].questionLanguage[indiceIdioma];
        let indiceIdiomaStt1 = this.catalogoRespForall[0].questionLanguage.findIndex(item => item.lang == datosTraduccion.lang);
        let indiceIdiomaStt2 = this.catalogoRespForall[1].questionLanguage.findIndex(item => item.lang == datosStt2.lang);

        // datosStt1.question = this.catalogoRespForall[0].questionLanguage[indiceIdiomaStt1].question.replace("$replace1",datosTraduccion.practice4all);
        // datosStt1.practice4all = datosTraduccion.practice4all;
        // datosStt1.description4all = datosTraduccion.description4all;
        // datosTraduccion.question = this.catalogoRespForall[1].questionLanguage[indiceIdiomaStt2].question.replace("$replace1",datosTraduccion.practice4all).replace("$replace2",this.jsonCuestionario.companyId.datosEmpresa.nombreEmpresa);
        datosTraduccion.question = this.catalogoRespForall[0].questionLanguage[indiceIdiomaStt2].question.replace("$replace1",datosTraduccion.practice4all);
        datosStt2.question = this.catalogoRespForall[1].questionLanguage[indiceIdiomaStt1].question.replace("$replace1",datosTraduccion.practice4all).replace("$replace2",this.jsonCuestionario.companyId.datosEmpresa.nombreEmpresa);
        datosStt2.practice4all = datosTraduccion.practice4all;
        // datosStt1.description4all = datosTraduccion.description4all;
        console.log("seccionesDemo:",this.seccionesDemo);

        this.actualizaCuestionario.emit(true);
        switch (tipoTexto) {
          case 1: //practica
            this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].practice4all = event.target.value;
            this.traduccionesOriginal[indiceSeccion].questions[indicePregunta + 1].questionLanguage[indiceIdioma].practice4all = event.target.value;
          break;
          case 2: //descripcion
            this.traduccionesOriginal[indiceSeccion].questions[indicePregunta].questionLanguage[indiceIdioma].description4all = event.target.value;
            // this.traduccionesOriginal[indiceSeccion].questions[indicePregunta + 1].questionLanguage[indiceIdioma].description4all = event.target.value;
          break;
        }
      }
      else console.log("es el mismo texto nomms :v");

    }
  }

  modalGuardado(opcion:number){
    let mensaje: string;
    switch (opcion) {
      case 1:
        // this.translate.get('Guardando traducción del nombre, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRADU_PRAC')
      break;
      case 2:
        // this.translate.get('Guardando traducción de la pregunta, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRADU_DESCR')
      break;
      case 3:
        // this.translate.get('Guardando traducción de la opción de respuesta, espere por favor').subscribe((res: string) => { mensaje = res; });
        mensaje = this.translateSrv.instant('CERTIFICARV3.TAB_TRADUCCION.GUAR_TRA_RES')
      break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    this.revisaTraduccionesCompletas();
  }

  openSuccessSnackBar(message: string, action: string) {
     this.snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['background-success']
     });
  }

  //// AUDIOS

  DEMO_convierteAudioBlob(base64:string){
    const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    const contentType = 'audio/mpeg';
    const b64Data = base64;

    const blob = b64toBlob(b64Data, contentType);
    const blobUrl = URL.createObjectURL(blob);
    // this.blobAudio = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
    return blobUrl;
  }

  DEMO_agregarAudioPregunta(datosPregunta:any, tipo:string){
    // let datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    const dialogRef = this.dialog.open(ModalComponent, {
      disableClose: true,
      width: '60%',
      data: {
        opcion: 'nuevoAudio',
        tipo,
        idiomas: this.idiomas,
        datosPregunta
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result != undefined){
        if(result.base64 != undefined){
          datosPregunta.audio = true;
          datosPregunta.audioData = '';
          datosPregunta.audioUrl = ''
          setTimeout(() => {
            datosPregunta.audioData = result.base64;
            datosPregunta.audioUrl = result.url
          });
          this.actualizaCuestionario.emit(true);
        }
      }
    });
  }

  DEMO_reproducirAudioPregunta(datosPregunta:any, statement:number){
    // const datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    datosPregunta.audioUrl = this.DEMO_convierteAudioBlob(datosPregunta.audioData);
  }

  DEMO_borrarAudioPregunta(datosPregunta:any, statement:number){
    // let datosPregunta = this.DEMO_buscaObjetoStatement(posicion, statement);
    Swal.fire({
      icon: 'question',
      title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRAR'),
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
      confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR'),
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.value) {
        const codigo = Math.random().toString(36).substring(7);
        Swal.fire({
          title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CONFIRMAR_BORRAR') + '<font color="red">' + codigo + '</font>',
          icon: 'info',
          input:'text',
          showCancelButton: true,
          reverseButtons: true,
          cancelButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.CANCELAR'),
          confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.BOTONES.ACEPTAR')
        }).then( (borrar) => {
          if (borrar.value == codigo) {
            datosPregunta.audio = false;
            datosPregunta.audioData = '';
            datosPregunta.audioUrl = '';
            this.openSuccessSnackBar(this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.BORRADO_OK'), "OK");
          } else{
            if(!borrar.dismiss){
              Swal.fire({
                icon: 'error',
                title: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.MODALES.CODIGO_MAL'),
                showConfirmButton: true,
                confirmButtonText: this.translateSrv.instant('CERTIFICARV3.MODAL_AUDIO.ACEPTAR')
              })
            }
          }
        });
      }
    });
  }

}
